import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { appIcon } from '../../assets';
import { getShowFlatshow } from '../../store/requests/app/selector';
import { useStyles } from './styles';

export const FlatShowLogo: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  const isShowFlatshow = useSelector(getShowFlatshow);
  const show = useMemo(() => {
    if (isVisible !== undefined) return isVisible;
    return isShowFlatshow;
  }, [isVisible, isShowFlatshow]);
  const styles = useStyles({});

  return (
    <>
      { show && (
        <a
          className={cx(styles.flatshowLink, 'flatshowLink')}
          href="https://www.flat.show"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img width={32} height={34} src={appIcon.mainLogo.default} alt="logo" />
        </a>
      ) }
    </>
  );
};
